// extracted by mini-css-extract-plugin
module.exports = {"styles":"_2Wsjja9pr83SXGNDjekgE3"};